import React, { useState, useEffect, useRef } from 'react';
import './EditableSegment.css';
import { FaRegCircleXmark } from 'react-icons/fa6';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import { Snackbar, Alert } from '@mui/material';

const NoConnection = () => {
  const { token } = useAuth();
  // State for managing editing status
  const [editingSegment, setEditingSegment] = useState(null);

  // State for each editable segment
  const [textContent, setTextContent] = useState(
    'Your service is temporarily disconnected'
  );
  const [descriptionContent, setDescriptionContent] = useState(
    'We regret to inform you that your internet connection has been temporarily disconnected due to an overdue payment. Pay immediately to restore your service.'
  );
  const [buttonLabel, setButtonLabel] = useState('Make a Payment Now!');
  const [buttonStyles, setButtonStyles] = useState({
    backgroundColor: '#D93024',
    textColor: '#FFFFFF',
    cornerRadius: '23px',
  });
  const [buttonStyles2, setButtonStyles2] = useState({
    backgroundColor: '#E2E2E2',
    textColor: '#262626',
    cornerRadius: '23px',
  });

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const imageRef = useRef();
  const [uploadStatus, setUploadStatus] = useState('');

  const [templates, setTemplates] = useState([]);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  // Function to initiate editing
  const handleEditClick = (segment) => {
    setEditingSegment(segment);
  };

  const showSnackbar = (message, severity, isOpen) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(isOpen); // Use the isOpen parameter to control the snackbar's state
  };

  // Function to save content and stop editing
  // const handleSave = () => {
  //   setEditingSegment(null);
  //   console.log(textContent, descriptionContent, buttonLabel, buttonStyles, buttonStyles2);
  // };
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data; // returns the list of templates
    } catch (error) {
      console.error('Error fetching templates:', error);
      return []; // return an empty array or handle the error as needed
    }
  };

  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };
    loadTemplates();
  }, [fetchTrigger]);

  const template_name = 'gardenwall-noconnection';

  useEffect(() => {
    const urlPath = window.location.pathname; // Get the URL path
    if (urlPath.includes('create')) {
      console.log('Create mode detected, skipping template parsing.');
      return;
    }
    if (templates && templates.length > 0) {
      // console.log('Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          // console.log('Template data:', template_data);
          setTextContent(template_data.textContent);
          setDescriptionContent(template_data.descriptionContent);
          setButtonStyles(template_data.buttonStyles);
          setButtonStyles2(template_data.buttonStyles2);
          setImageUrl(template_data.image);
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        // console.log('Specific template not found');
      }
    }
  }, [templates]);

  const handleSave = async () => {
    const formData = new FormData();
    // let template_name = 'gardenwall-noconnection-1';
    formData.append('template_name', template_name);

    const appendDataAndSend = async (imageData) => {
      formData.append(
        'template',
        JSON.stringify({
          textContent,
          descriptionContent,
          buttonLabel,
          buttonStyles,
          buttonStyles2,
          image: imageData,
        })
      );

      const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
      let url = `${urlBase}/create`; // Default to create URL
      let method = 'post'; // Default method for creation

      // Check if specific template already exists
      if (templates && templates.length > 0) {
        const specificTemplate = templates.find(
          (template) => template.template_name === template_name
        );
        if (specificTemplate && specificTemplate.id) {
          url = `${urlBase}/update/${specificTemplate.id}`; // Adjust URL for update
          method = 'put'; // Use PUT for updates
        }
      }

      try {
        const response = await axios({
          method: method,
          url: url,
          data: formData,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`, // Authorization header
          },
        });
        // console.log('Response Data:', response.data);
        setFetchTrigger((oldTrigger) => oldTrigger + 1);
      } catch (error) {
        console.error('Error saving template:', error);
      }

      setEditingSegment(null);
    };
    console.log(image);
    if (image) {
      fileToBase64(image, async (base64Image) => {
        await appendDataAndSend(base64Image);
      });
    } else {
      await appendDataAndSend(imageUrl);
    }
  };

  const fileToBase64 = (file, callback) => {
    console.log(file);
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => callback(reader.result);
      reader.onerror = (error) => {
        console.error('Error converting file to base64:', error);
      };
    } else {
      console.error('Provided file is not a Blob:', file);
    }
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return; // Prevents closing when clicking outside
    setSnackbarOpen(false);
  };
  const handleClick = () => {
    if (imageRef.current) {
      imageRef.current.click(); // Ensure ref exists before calling click()
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    // alert('yes');
    if (file) {
      // Check if the file is an image
      if (file.type.startsWith('image')) {
        // console.log(2);
        setImage(file);
        // console.log(image);
        setUploadStatus('Image loaded successfully.');
        showSnackbar('Image loaded successfully.', 'success', true);

        setTimeout(() => {
          console.log('Image set for upload:', image);
          //if(image){ handleSave(); }
        }, 0);
      } else {
        setUploadStatus('Please upload an image file.');
        showSnackbar(
          'Invalid format! Please upload a PNG, JPG, or GIF image.',
          'error',
          true
        );
      }
    }
  };

  useEffect(() => {
    if (image) {
      console.log('Image ready for processing:', image);
      handleSave(); // Call save method after image state is updated
    }
  }, [image]);

  const renderImageUpload = () => (
    <>
      <div
        className="upload-btn-wrapper"
        style={{
          position: 'relative',
          display: 'inline-block',
          cursor: 'pointer',
        }}
        onClick={handleClick} // Ensures click event is handled correctly
      >
        <button className="btn" style={{ cursor: 'pointer' }}>
          Upload a file
        </button>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={imageRef}
          style={{ display: 'none' }} // Hide input but keep it functional
        />
      </div>

      {/*<div class="upload-btn-wrapper">
        <button class="btn">Upload a file</button>
        <input type="file" accept="image/*" onChange={handleImageChange} ref={imageRef} />
      </div>*/}
      <br></br>
      <span>PNG, JPG or GIF</span>
      <br></br>
      {uploadStatus && <p>{uploadStatus}</p>}
    </>
  );

  return (
    <div className="editable-container">
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* Image Section */}
      <div className="editable-image">
        {/* <img src="../../../images/no-wifi.svg" alt="Service Icon" /> */}
        {/* {image && <img src={URL.createObjectURL(image)} alt="Uploaded" style={{ width: '100px', height: 'auto' }} />} */}
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Uploaded"
            style={{ width: '100px', height: 'auto' }}
          />
        )}
        <button
          className={`edit-icon-button ${editingSegment === 'image' ? 'act' : ''}`}
          onClick={() => handleEditClick('image')}
        ></button>
        {editingSegment === 'image' && <div>{renderImageUpload()}</div>}
      </div>

      {/* Main Heading Section */}
      <div className="editable-text">
        {editingSegment === 'description' ? (
          <input
            type="text"
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            onBlur={handleSave}
          />
        ) : (
          <h2>{textContent}</h2>
        )}
        {/* {editingSegment !== 'text' && (
          <button className="edit-icon-button" onClick={() => handleEditClick('text')}></button>
        )} */}
        {/* </div> */}

        {/* Description Section */}
        {/* <div className="editable-description"> */}
        {editingSegment === 'description' ? (
          <textarea
            value={descriptionContent}
            onChange={(e) => setDescriptionContent(e.target.value)}
            onBlur={handleSave}
          />
        ) : (
          <p>{descriptionContent}</p>
        )}
        {
          <button
            className={`edit-icon-button ${editingSegment === 'description' ? 'act' : ''}`}
            onClick={() => handleEditClick('description')}
          ></button>
        }
      </div>

      {/* Button Section */}
      <div className="editable-button">
        <button
          style={{
            backgroundColor: buttonStyles.backgroundColor,
            color: buttonStyles.textColor,
            borderRadius: buttonStyles.cornerRadius,
            marginRight: '15px', // Add space to the right of this button
          }}
        >
          {buttonLabel}
        </button>
        {
          <button
            className={`edit-icon-button ${editingSegment === 'button' ? 'act' : ''}`}
            onClick={() => handleEditClick('button')}
          ></button>
        }

        {editingSegment === 'button' && (
          <div className="button-edit-panel">
            {/* <label>
              Button Label:
              <input
                type="text"
                value={buttonLabel}
                onChange={(e) => setButtonLabel(e.target.value)}
              />
            </label> */}
            <span>
              <label> Button background: </label>
              <input
                type="color"
                onBlur={handleSave}
                value={buttonStyles.backgroundColor}
                onChange={(e) =>
                  setButtonStyles((prev) => ({
                    ...prev,
                    backgroundColor: e.target.value,
                  }))
                }
              />
              <span className="color-code">
                <b
                  style={{ backgroundColor: buttonStyles.backgroundColor }}
                ></b>
                {buttonStyles.backgroundColor}
              </span>
            </span>
            <span>
              <label> Button text: </label>
              <input
                type="color"
                onBlur={handleSave}
                value={buttonStyles.textColor}
                onChange={(e) =>
                  setButtonStyles((prev) => ({
                    ...prev,
                    textColor: e.target.value,
                  }))
                }
              />
              <span className="color-code">
                <b style={{ backgroundColor: buttonStyles.textColor }}></b>
                {buttonStyles.textColor}
              </span>
            </span>
            <span>
              <label> Corner radius: </label>
              <input
                type="number"
                onBlur={handleSave}
                value={buttonStyles.cornerRadius.replace('px', '')}
                onChange={(e) =>
                  setButtonStyles((prev) => ({
                    ...prev,
                    cornerRadius: `${e.target.value}px`,
                  }))
                }
              />
            </span>
            {/* <button onClick={handleSave}>Save</button> */}
          </div>
        )}
      </div>

      {/* Footer Buttons */}
      <div className="footer-buttons">
        <button
          style={{
            backgroundColor: buttonStyles2.backgroundColor,
            color: buttonStyles2.textColor,
            borderRadius: buttonStyles2.cornerRadius,
          }}
        >
          View Invoice
        </button>
        <button
          style={{
            backgroundColor: buttonStyles2.backgroundColor,
            color: buttonStyles2.textColor,
            borderRadius: buttonStyles2.cornerRadius,
          }}
        >
          Contact Us
        </button>

        {
          <button
            className={`edit-icon-button ${editingSegment === 'button-2' ? 'act' : ''}`}
            onClick={() => handleEditClick('button-2')}
          ></button>
        }

        {editingSegment === 'button-2' && (
          <div className="button-edit-panel">
            {/* <label>
              Button Label:
              <input
                type="text"
                value={buttonLabel}
                onChange={(e) => setButtonLabel(e.target.value)}
              />
            </label> */}
            <span>
              <label> Outline color: </label>
              <input
                type="color"
                onBlur={handleSave}
                value={buttonStyles2.backgroundColor}
                onChange={(e) =>
                  setButtonStyles2((prev) => ({
                    ...prev,
                    backgroundColor: e.target.value,
                  }))
                }
              />
              <span className="color-code">
                <b
                  style={{ backgroundColor: buttonStyles2.backgroundColor }}
                ></b>
                {buttonStyles2.backgroundColor}
              </span>
            </span>
            <span>
              <label> Text color: </label>
              <input
                type="color"
                onBlur={handleSave}
                value={buttonStyles2.textColor}
                onChange={(e) =>
                  setButtonStyles2((prev) => ({
                    ...prev,
                    textColor: e.target.value,
                  }))
                }
              />
              <span className="color-code">
                <b style={{ backgroundColor: buttonStyles2.textColor }}></b>
                {buttonStyles2.textColor}
              </span>
            </span>
            <span>
              <label> Corner radius: </label>
              <input
                type="number"
                onBlur={handleSave}
                value={buttonStyles2.cornerRadius.replace('px', '')}
                onChange={(e) =>
                  setButtonStyles2((prev) => ({
                    ...prev,
                    cornerRadius: `${e.target.value}px`,
                  }))
                }
              />
            </span>
          </div>
        )}
      </div>
      {/* <button className='btn' style={{top:'100px'}} onClick={handleSave}>Save</button> */}
    </div>
  );
};

export default NoConnection;
